export enum WeeklyScheduleScreenNames {
  MAIN = 'weekly-schedule-nav',
  WEEKLY_SCHEDULE = 'weekly-schedule',
}
